/**
 * Directive: relink
 */
angular.module('acme.common.directive.relink', [
  'ui.bootstrap'
])
.directive('relink', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/relink/relink.tpl.html',
      scope: {
        modified: '=',
        templateName: '=',
        onLink: '&',
        onUnlink: '&',
        confirm: '@',
        confirmMessage: '@',
        tooltipPlacement: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$uibModal', function($scope, $uibModal) {

        $scope.relink = {

          modalDialog: false,

          tooltip: {
            delay: 750,
            placement: $scope.tooltipPlacement || 'top',
            linked: 'Linked to the parent template.',
            unlinked: 'Not linked to the parent template.'
          },

          init: function() {
            $scope.$on('$destroy', $scope.$watch('templateName', this.onTemplateNameUpdate));
          },

          link: function() {
            var self = $scope.relink;

            if ($scope.confirm && ($scope.confirm === true || $scope.confirm === 'true')) {
              self.modalDialog = $uibModal.open({
                templateUrl: 'common/directives/relink/modals/relinkConfirm.tpl.html',
                size: 'md',
                controller: [ '$scope', '$uibModalInstance', 'message', function ($scope, $uibModalInstance, message) {

                  $scope.model = {};

                  $scope.init = function() {
                    this.model = message;
                  };

                  $scope.done = function() {
                    $scope.success();
                  };

                  $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                  };

                  $scope.success = function () {
                    $uibModalInstance.close(true);
                  };

                  $scope.init();

                }],
                resolve: {
                  message: function() {
                    return $scope.confirmMessage || '';
                  }
                }
              });

              // Invoked when modal completes with close(params)
              self.modalDialog.result.then(function (name) {
                self.completeLink();
              }, function () {
                // Do nothing
              });
            } else {
              self.completeLink();
            }

          },

          completeLink: function() {
            $scope.modified = false;
            $scope.onLink();
          },

          unlink: function() {
            /* TODO:
             * Review linking not currently allowed
             * may need to be re-enabled
             */
            // $scope.modified = true;
            // $scope.onUnlink();
          },

          onTemplateNameUpdate: function(n, o) {
            var self = $scope.relink;

            if (n) {
              self.tooltip.linked = 'Linked to the \'' + n + '\' template.';
              self.tooltip.unlinked = 'Not linked to the \'' + n + '\' template.';
            }
          }

        };

        $scope.relink.init();

      }]

    };

}]);